export default function SubGroupItem({ subGroup, onClick, active }) {
    const { name, cover } = subGroup;

    const handleClick = () => {
        // Call the provided onClick function when the component is clicked
        if (onClick) {
            onClick(subGroup);
        }
    };

    return (
        <div
            key={name + `SubCategory_${name}`}
            className={"Subcategory"}
            onClick={handleClick}
            style={{
                border: active ? "3px solid #e14954" : "none",
                cursor: "pointer",
            }}
        >
            <div
                key={name + `SubCategory_1_${name}`}
                className={"Subcategory__Name"}
            >
                {/* {name} */}
            </div>
            <div
                key={name + `SubCategory_2_${name}`}
                className={"Subcategory__Img"}
                style={{
                    backgroundImage: `url(${cover})`,
                }}
            ></div>
        </div>
    );
}
